import * as d3 from 'd3'
import moment from 'moment'


export default {

  methods: {

    set_LocalValues(){
      // raw data
      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      let sql1 = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.chartData.forEach(d=> {
        let eDate = moment(`${d.CDATE} 23:59:59`).toDate()
        let sDate = moment(d.CDATE).add(-6, 'days').toDate()
        d.mDate = new Date(d3.mean([sDate, eDate]))
      })

      this.title      = json.title
      this.legends    = json.legends

      this.primary    = {...json.primary,
        axis: null, 
        max: null,
      }

      this.secondary = {...json.secondary,
        axis: null, 
        max: null,
      }

      this.chart      = json.chart
      this.group      = json.group
      this.keys       = json.keys
      this.filters    = json.filters
      this.sundries   = json.sundries


      this.timeline = {
        cutoff    : sql1.CUTOFF,
        startDate : sql1.START_DATE,
        endDate   : sql1.END_DATE,
        weekEnd   : 'friday',

        day        : [],
        week       : [],
        month      : [],
        year       : [],
        scale      : null,
        length     : this.chart.width,
      }
      this.gmx_TimelineValues(this.timeline, 'day')
      
    },

  }
}